import React, { useEffect, useState } from "react";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  TableHead,
  Box,
  Button,
  Container,
  Typography,
} from "@mui/material";
import "../styles/productDenomination.css";
import DenominationTable from "./DenominationTable";
import RangeDenomination from "./RangeDenomination";
import { useDispatch, useSelector } from "react-redux";
import {
  addNewDenomination,
  wipeOutDenomination,
} from "../../../store/productDetails/action";
import { handleAmount } from "../../../shared/extra";
import UserPayButton from "../payment/paymentUtils/UserPayButton";
import PayFromWallet from "../payment/paymentUtils/PayFromWallet";

import { useAuth } from "../../../hooks/contexts/AuthContext";
import OrderReceiver from "../payment/paymentUtils/orderReceiver";
import PaymentOrderReceipt from "../payment/paymentUtils/PaymentOrderReceipt";
import VerifiedIcon from '@mui/icons-material/Verified';
import { capitalizeFirst } from "../../../hooks/utilsFn/utilsFn";
import AmericanPay from "../../../assets/others/american.webp"
import VisaPay from "../../../assets/others/visa.webp"
import ApplePay from "../../../assets/others/apple_pay.png"
import MasterPay from "../../../assets/others/Mastercard.png"

export default function ProductDenomination() {
  const PRODUCTDETAILS = useSelector((state) => state.ProductDetail?.allData);
  const DENOMINATION_STORE_DATA = useSelector(
    (state) => state.Denominations?.allData,
  );
  const [walletPayment, setWalletPayment] = useState(false);
  const ProductType = DENOMINATION_STORE_DATA?.[0]?.DISCOUNT_TYPE

  const { isLoggedIn } = useAuth();
  const dispatch = useDispatch();

  // reciver data
  const [receiverData, setReceiverData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
  });
  const [receiverErrorOpen, setReceiverErrorOpen] = useState(false);

  // Reset reducer
  useEffect(() => {
    dispatch(wipeOutDenomination());
  }, [PRODUCTDETAILS?.id]);

  // Button click funtion
  const handleAmountClick = (item) => {
    const numericAmt = Number(item.platformAmount);

    if (isNaN(numericAmt)) return;

    const isDuplicate = DENOMINATION_STORE_DATA?.some(
      (data) => Number(data.AMOUNT) === numericAmt,
    );

    if (isDuplicate) {
      return;
    }

    const resslerDicount = item?.userProductDenominationDiscounts
    const denominationObject = {
      AMOUNT: numericAmt,
      DISCOUNT: Number(resslerDicount?.[0]?.discountValue) || Number(item.value),
      DISCOUNT_TYPE: item?.cashbackOrDiscount,
      QUANTITY: 1,
      TOTAL: numericAmt,
      MAX_LIMIT: PRODUCTDETAILS?.max_quantity || 5,
      DENOM_TYPE: "FIXED",
      PRODUCT_CODE: null,
      PRODUCT_GUID: null,
      PRODUCT_ID: item.productId,
      SUB_PRODUCT_ID: null,
      SKU_ID: null,
      ISCASHBACK_PRODUCT: PRODUCTDETAILS?.isCashbackProduct || false,
      PRODUCT_TYPE: PRODUCTDETAILS?.cashbackOrDiscount || null,
      CASHBACK_AMOUNT: null,
      DENOMINATION_ID: item?.id || null,
      CURRENCY: item?.currency
    };

    dispatch(addNewDenomination(denominationObject));
  };

  return (
    <>
      <Container
        maxWidth="false"
        disableGutters
        sx={{
          border: "1.8px solid #E4C18F",
          borderRadius: {
            xs: 3,
            md: 5,
          },
          px: {
            xs: 1,
            md: 3,
          },
          py: {
            xs: 0,
            md: 1,
          },
          mt: {
            xs: 0,
            md: 5,
          },
        }}
      >
        <Box>
          <Typography
            sx={{
              fontSize: { xs: "16px", sm: "18px ", lg: '20px' },
              mt: 2,
              fontWeight: 500,
              color: "#002865",
              fontFamily: "Onest",
            }}
          >
            Select Denomination
          </Typography>
        </Box>

        {/* FIXED BUTTONS */}
        {PRODUCTDETAILS?.fixedDenomination && (
          <Box sx={{ display: "flex", gap: 4, flexWrap: "wrap", mb: 2, mt: 2 }}>
            {PRODUCTDETAILS?.denominations?.map((item, index) => {
              const numericAmt = Number(item?.platformAmount);
              const isSelected = DENOMINATION_STORE_DATA?.some(
                (data) => Number(data?.platformAmount) === numericAmt,
              );

              return (
                <Button
                  key={index}
                  onClick={() => handleAmountClick(item)}
                  disabled={isSelected}
                  sx={{
                    borderRadius: 5,
                    py: 0.5,
                    px: 3,
                    background: isSelected ? "#002865" : "none !important",
                    color: isSelected ? "#FFFFFF" : "#000000 !important",
                    fontFamily: "Be Vietnam Pro",
                    fontWeight: 600,
                    fontSize: { xs: "11.5px", lg: "13px" },
                    border: "1px solid #E4C18F",
                    "&:hover": {
                      background: "#F9F2F0",
                      color: "#000",
                      fontWeight: 600,
                      fontFamily: "Be Vietnam Pro",
                      border: "1px solid #E4C18F",
                    },
                    "&.Mui-disabled": {
                      backgroundColor: "#002865",
                      color: "#FFFFFF",
                      border: "2px solid #002865",
                      opacity: 1,
                    },
                  }}
                >
                  AED {handleAmount(numericAmt)}
                </Button>
              );
            })}
          </Box>
        )}

        {/* RANGE */}
        {PRODUCTDETAILS?.rangeDenomination && (
          <RangeDenomination />
        )}

        {/* TABLE */}
        {DENOMINATION_STORE_DATA?.length > 0 && (
          <TableContainer
            sx={{
              width: "100%",
              overflowX: "hidden",
            }}
          >
            <Table
              sx={{
                borderCollapse: "separate",
                borderSpacing: "0 12px",
                width: "100%",
                tableLayout: "fixed",
              }}
            >
              {/* HEADER */}
              <TableHead>
                <TableRow>
                  {[
                    "Amount",
                    "Quantity",
                    capitalizeFirst(ProductType),
                    "Total",
                    PRODUCTDETAILS?.rangeDenomination && "Action",
                  ]
                    .filter(Boolean)
                    .map((head, i, arr) => (
                      <TableCell
                        key={i}
                        align="center"
                        sx={{
                          backgroundColor: "#002865",
                          color: "#fff",
                          fontFamily: "Be Vietnam Pro",
                          fontSize: PRODUCTDETAILS?.rangeDenomination ?
                            { xs: "11px", sm: "9px", md: "11px", lg: "14px" } :
                            { xs: "13px", sm: "10px", md: "13px", lg: "16px" },

                          border: "none",
                          py: 1.5,
                          ...(head === "Action" && {
                            px: 0.5,
                          }),

                          ...(i === 0 && {
                            borderTopLeftRadius: "10px",
                            borderBottomLeftRadius: "10px",
                          }),
                          ...(i === arr.length - 1 && {
                            borderTopRightRadius: "10px",
                            borderBottomRightRadius: "10px",
                          }),
                        }}
                      >
                        {head}
                      </TableCell>
                    ))}
                </TableRow>
              </TableHead>

              {/* BODY */}
              <TableBody>
                <DenominationTable />
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {/* PAYMENT */}
        <Box sx={{ mt: 2 }}>
          <PaymentOrderReceipt walletPayment={walletPayment} />
        </Box>
      </Container>
      {isLoggedIn && (

        <OrderReceiver
          receiverData={receiverData}
          setReceiverData={setReceiverData}
          forceOpen={receiverErrorOpen}
        />
      )}

      {/* wallet payment component */}
      {isLoggedIn && (
        <PayFromWallet
          walletPayment={walletPayment}
          setWalletPayment={setWalletPayment}
        />
      )}



      {/* user pay button  */}
      <UserPayButton
        receiverData={receiverData}
        setReceiverErrorOpen={setReceiverErrorOpen}
        walletPayment={walletPayment}
      />

      <Typography
        sx={{
          color: "#000",
          fontFamily: "Be Vietnam Pro",
          fontWeight: 500,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 0.5,
          mt: 1
        }}
      >

        Safe & Secure Payment
        <VerifiedIcon htmlColor="#00A933" />
      </Typography>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: { xs: 1, sm: 1.5 },
          flexWrap: "wrap",
          mt: 1,
        }}
      >
         <Box
          component="img"
          src={VisaPay}
          alt="Visa"
          sx={{
            width: { xs: 40, sm: 58 },
            height: { xs: 26, sm: 30 },
            objectFit: "contain",
          }}
        />
<Box
          component="img"
          src={MasterPay}
          alt="Mastercard"
          sx={{
            width: { xs: 40, sm: 58},
            height: { xs: 26, sm: 30 },
            objectFit: "contain",
          }}
        />
          <Box
          component="img"
          src={ApplePay}
          alt="Apple Pay"
          sx={{
            width: { xs: 40, sm: 58},
            height: { xs: 26, sm: 48 },
            objectFit: "contain",
          }}
        />

        <Box
          component="img"
          src={AmericanPay}
          alt="American Express"
          sx={{
            width: { xs: 40, sm: 58 },
            height: { xs: 26, sm: 48 },
            objectFit: "contain",
          }}
        />


      </Box>
    </>
  );
}
